import React, { useEffect, useState } from 'react';
import { Link2, RefreshCw } from 'lucide-react';
import api from '../../api/client';

// Lista d'ingresso FIPAV completa del torneo (28/10, titolare: "vedo solo i nostri atleti e non tutti quelli
// realmente presenti"). Tutte le coppie nell'ordine FIPAV, le nostre evidenziate; il nostro ordine di società
// resta nel Tabellone. Usata nella finestra del torneo e dal Tabellone società.
const ESITO = {
  'Main Draw':  { l: 'Tabellone principale', col: '#15803D', bg: '#DCFCE7' },
  'Qualifiche': { l: 'Qualificazioni',       col: '#1D4ED8', bg: '#DBEAFE' },
  'Riserva':    { l: 'Riserva',              col: '#B45309', bg: '#FEF3C7' },
};
const titolo = (n) => n.toLowerCase().replace(/(^|[\s'-])\S/g, c => c.toUpperCase());

export default function ListaFipavCompleta({ torneoId, headers }) {
  const [dati, setDati] = useState(null);
  const [err, setErr] = useState('');
  const [soloNostre, setSoloNostre] = useState(false);

  useEffect(() => {
    let vivo = true;
    api.get(`/fipav/tornei/${torneoId}/lista-fipav`, headers ? { headers } : undefined)
      .then(r => { if (vivo) setDati(r.data); })
      .catch(e => { if (vivo) setErr(e.response?.data?.error || e.message); });
    return () => { vivo = false; };
  }, [torneoId, headers]);

  if (err) return <div style={{ color: '#B42318', fontSize: '13px' }}>{err}</div>;
  if (!dati) return <div style={{ color: 'var(--text-muted)', fontSize: '13px', display: 'flex', gap: '6px', alignItems: 'center' }}><RefreshCw size={13} /> Carico la lista FIPAV…</div>;
  if (!dati.coppie.length) return <div style={{ color: 'var(--text-muted)', fontSize: '13px' }}>FIPAV non ha ancora pubblicato coppie per questo torneo.</div>;

  const righe = soloNostre ? dati.coppie.filter(c => c.nostra) : dati.coppie;
  return (
    <div>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '8px', fontSize: '13px' }}>
        <span><b>{dati.coppie.length}</b> coppie{dati.posti ? ` per ${dati.posti} posti` : ''} · <b style={{ color: '#F4600C' }}>{dati.nostre}</b> B-Cheers
          {dati.lista_ufficiale === false && ' · provvisoria'}{dati.lista_ufficiale === true && ' · ufficiale'}</span>
        <label style={{ display: 'flex', gap: '5px', alignItems: 'center', cursor: 'pointer' }}>
          <input type="checkbox" checked={soloNostre} onChange={e => setSoloNostre(e.target.checked)} /> Solo B-Cheers
        </label>
        {dati.link_entry && <a href={dati.link_entry} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', gap: '4px', alignItems: 'center', color: 'var(--text-muted)', fontSize: '12px' }}><Link2 size={13} /> sito FIPAV</a>}
      </div>
      <div style={{ border: '1px solid var(--border, #E5E5EA)', borderRadius: '10px', overflow: 'hidden' }}>
        {righe.map((c, i) => {
          const e = ESITO[c.nota];
          return (
            <div key={`${c.pos}-${i}`} style={{ display: 'grid', gridTemplateColumns: '34px 1fr auto', gap: '8px', alignItems: 'center', padding: '7px 10px', fontSize: '13px',
              borderTop: i ? '1px solid var(--border, #E5E5EA)' : 'none', background: c.nostra ? '#F4600C14' : 'transparent', borderLeft: c.nostra ? '3px solid #F4600C' : '3px solid transparent' }}>
              <span style={{ color: 'var(--text-muted)', fontWeight: 700, textAlign: 'right' }}>{c.pos ?? '—'}</span>
              <span style={{ minWidth: 0 }}>
                {c.atleti.map((a, j) => (
                  <span key={j}>{j > 0 && ' – '}<span style={{ fontWeight: a.nostro ? 700 : 400, color: a.nostro ? '#C2410C' : 'inherit' }}>{titolo(a.nome)}</span></span>
                ))}
                {c.nostra && <span style={{ marginLeft: '6px', fontSize: '11px', fontWeight: 800, color: '#F4600C' }}>★ B-CHEERS</span>}
                {c.cambio && <div style={{ fontSize: '11px', color: '#B45309' }}>Cambio coppia: {c.cambio}</div>}
              </span>
              {e ? <span style={{ fontSize: '11px', fontWeight: 700, padding: '2px 8px', borderRadius: '99px', color: e.col, background: e.bg, whiteSpace: 'nowrap' }}>{e.l}</span>
                 : <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>{c.nota || ''}</span>}
            </div>
          );
        })}
        {!righe.length && <div style={{ padding: '12px', fontSize: '13px', color: 'var(--text-muted)' }}>Nessuna coppia B-Cheers nella lista FIPAV.</div>}
      </div>
      <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '6px' }}>Ordine e esito sono quelli della lista FIPAV, che fa sempre fede. Le coppie B-Cheers sono riconosciute dal numero di tessera FIPAV (lista provvisoria) o dalla società (lista ufficiale).</div>
    </div>
  );
}
